<template>
  <div>
    <div
      v-show="isActive"
      class="sidebar bg-primary animated fadeIn faster m-2 p-3 text-light big-sidebar show-sidebar"
    >
      <div class="row justify-content-center mx-auto mb-2">
        <h3 class="col-auto align-self-center text-white py-2 mb-0">
          <i class="fas fa-1x fa-search" id="filterIcon"></i> Search
        </h3>
        <span class="col-md-auto col-12 align-self-center py-2">
          <input
            v-model="selectedFilters.searchTerm"
            type="text"
            class="form-control"
            id="search"
            placeholder="Search by model..."
          />
        </span>
        <span class="col-auto align-self-center py-2">
          <router-link to="/" class="btn btn-success text-white mr-1">
            <span @click="isActive = false">
              <i class="fa fa-search"></i> Search
            </span>
          </router-link>
          <button
            class="btn btn-danger text-white mr-1"
            @click="isActive = false"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button class="btn btn-warning text-dark" @click="resetFilter()">
            <i class="fa fa-sync"></i> Reset
          </button>
        </span>
      </div>
      <hr class="my-1" />
      <div class="row">
        <div class="col-sm-6 col-12 px-2">
          <div class="col-12 my-2">
            <h5 class="text-warning">Demographic</h5>
            <label class="checkbox-inline w-45">
              <input
                type="checkbox"
                value="mmen"
                v-model="selectedFilters.demo"
              />Men
            </label>
            <label class="checkbox-inline w-45">
              <input
                type="checkbox"
                value="women"
                v-model="selectedFilters.demo"
              />Women
            </label>
          </div>

          <div class="col-12 my-2">
            <h5 class="text-warning">Material</h5>
            <label class="checkbox-inline w-45">
              <input
                type="checkbox"
                value="sda"
                v-model="selectedFilters.mat"
              />SDA
            </label>
            <label class="checkbox-inline w-45">
              <input
                type="checkbox"
                value="sdn-4"
                v-model="selectedFilters.mat"
              />SDN-4
            </label>
            <label class="checkbox-inline w-45">
              <input
                type="checkbox"
                value="sdn-6"
                v-model="selectedFilters.mat"
              />SDN-6
            </label>
            <label class="checkbox-inline w-45">
              <input
                type="checkbox"
                value="titanium"
                v-model="selectedFilters.mat"
              />Titanium
            </label>
          </div>

          <div class="col-12 my-2">
            <h5 class="text-warning">Shape</h5>
            <label class="checkbox-inline w-45">
              <input
                type="checkbox"
                value="aviator"
                v-model="selectedFilters.shape"
              />Aviator
            </label>
            <label class="checkbox-inline w-45">
              <input
                type="checkbox"
                value="butterfly"
                v-model="selectedFilters.shape"
              />Butterfly
            </label>
            <label class="checkbox-inline w-45">
              <input
                type="checkbox"
                value="cat-eye"
                v-model="selectedFilters.shape"
              />Cat Eye
            </label>
            <label class="checkbox-inline w-45">
              <input
                type="checkbox"
                value="oval"
                v-model="selectedFilters.shape"
              />Oval
            </label>
            <label class="checkbox-inline w-45">
              <input
                type="checkbox"
                value="rectangle"
                v-model="selectedFilters.shape"
              />Rectangle
            </label>
            <label class="checkbox-inline w-45">
              <input
                type="checkbox"
                value="round"
                v-model="selectedFilters.shape"
              />Round
            </label>
            <label class="checkbox-inline w-45">
              <input
                type="checkbox"
                value="square"
                v-model="selectedFilters.shape"
              />Square
            </label>
            <label class="checkbox-inline w-45">
              <input
                type="checkbox"
                value="rimless"
                v-model="selectedFilters.rim"
              />Rimless
            </label>
          </div>
        </div>
        <div class="col-sm-6 col-12 px-2">
          <div class="col-12 my-2">
            <h5 class="text-warning">Color</h5>
            <label class="checkbox-inline w-45">
              <input
                type="checkbox"
                value="black"
                v-model="selectedFilters.color"
              />Black
            </label>
            <label class="checkbox-inline w-45">
              <input
                type="checkbox"
                value="blue"
                v-model="selectedFilters.color"
              />Blue
            </label>
            <label class="checkbox-inline w-45">
              <input
                type="checkbox"
                value="brown"
                v-model="selectedFilters.color"
              />Brown
            </label>
            <label class="checkbox-inline w-45">
              <input
                type="checkbox"
                value="green"
                v-model="selectedFilters.color"
              />Green
            </label>
            <label class="checkbox-inline w-45">
              <input
                type="checkbox"
                value="grey"
                v-model="selectedFilters.color"
              />Grey
            </label>
            <label class="checkbox-inline w-45">
              <input
                type="checkbox"
                value="purple"
                v-model="selectedFilters.color"
              />Purple
            </label>
            <label class="checkbox-inline w-45">
              <input
                type="checkbox"
                value="red"
                v-model="selectedFilters.color"
              />Red
            </label>
            <label class="checkbox-inline w-45">
              <input
                type="checkbox"
                value="tortoise"
                v-model="selectedFilters.color"
              />Tortoise
            </label>
            <label class="checkbox-inline w-45">
              <input
                type="checkbox"
                value="white"
                v-model="selectedFilters.color"
              />White
            </label>
          </div>
          <div class="col-12 my-2">
            <h5 class="text-warning">Size / Specialty Fit</h5>
            <label class="checkbox-inline w-45">
              <input
                type="checkbox"
                value="petite-fit"
                v-model="selectedFilters.sp_fit"
              />Petite
            </label>
            <label class="checkbox-inline w-45">
              <input
                type="checkbox"
                value="small-fit"
                v-model="selectedFilters.sp_fit"
              />Small
            </label>
            <label class="checkbox-inline w-45">
              <input
                type="checkbox"
                value="med-fit"
                v-model="selectedFilters.sp_fit"
              />Medium
            </label>
            <label class="checkbox-inline w-45">
              <input
                type="checkbox"
                value="lg-fit"
                v-model="selectedFilters.sp_fit"
              />Large
            </label>
            <div class="col-12 text-center">
              <h6>
                <a class="text-warning" @click="$refs.sizeChart.show()">
                  <i class="fa fa-table"></i> View Size Chart
                </a>
              </h6>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SizeChart ref="sizeChart" />
  </div>
</template>

<script>
import SizeChart from "@/components/SizeChart.vue";

export default {
  name: "ProductFilter",
  components: { SizeChart },
  // props: {
  //   selectedFilters: { type: Object, required: true }
  // },
  data: function() {
    return {
      isActive: false,
      selectedFilters: {
        demo: [],
        res: [],
        mat: [],
        color: [],
        sp_fit: [],
        brand: ["brand-as"],
        rim: [],
        shape: [],
        searchTerm: ""
      }
    };
  },
  methods: {
    toggle() {
      this.isActive = !this.isActive;
    },
    resetFilter() {
      this.selectedFilters = {
        demo: [],
        res: [],
        mat: [],
        color: [],
        shape: [],
        sp_fit: [],
        brand: ["brand-as"],
        rim: [],
        searchTerm: ""
      };
    },
    getUrlVars() {
      var vars = {};
      window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(
        m,
        key,
        value
      ) {
        vars[key] = value;
      });
      return vars;
    }
  },
  created: function() {
    // get filters from url
    var urlFilters = this.getUrlVars();
    let i = 1;
    for (let filter in urlFilters) {
      // if (filter == 'nav') { app.showNav = false; i++; continue; }
      if (filter == "nav") {
        this.$emit("hideNav");
        i++;
        continue;
      }
      if (i == Object.keys(urlFilters).length) {
        this.selectedFilters[filter] = [
          urlFilters[filter].substring(0, urlFilters[filter].length - 2)
        ];
      } else this.selectedFilters[filter] = [urlFilters[filter]];
      i++;
    }
  },
  watch: {
    selectedFilters: {
      handler: function(val) {
        this.$emit("filterChange", val);
      },
      deep: true
    }
  }
};
</script>
